import React, {useEffect} from 'react'
import * as THREE from "three";
import { useSelector, useDispatch } from 'react-redux';
import { E_ConfOmbrelloniContrapposti, E_GenereOmbrellone, E_MainLato, E_TipoOmbrellone } from "../Utils/enumerations";
import { handleLunghezza, handleLarghezza} from "../../Redux/UIMenus/uiMainMenuSlice";
import { handleHasAttacchiEsterni } from '../../Redux/UIMenus/uiPedanaMenuSlice';
import { ombrelloniConfiguration } from '../Utils/meshesConfiguration';
import Minigonna from './Minigonna'
import Pavimento from './Pavimento'
import Piedini from './Piedini';
import PavimentoEsterno from "./PavimentoEsterno";
import { useState } from 'react';

// Genera la pedana
export default function Pedana() {
  const latoIngresso = useSelector(state => state.uiMainMenu.ingresso);
  const lunghezza = useSelector(state => state.uiMainMenu.lunghezza);
  const larghezza = useSelector(state => state.uiMainMenu.larghezza);
  const altezzaPedana = useSelector(state => state.uiPedanaMenu.realAltezza);
  const hasRampa = useSelector(state => state.uiPedanaMenu.rampaDisabili);
  const ombrelloniIsVisible = useSelector(state => state.uiOmbrelloniMenu.isVisible);
  const genereOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.genereOmbrellone);
  const tipoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.tipoOmbrellone);
  const dataOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.dataOmbrelloni);
  const latoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);
  const hasAttacchiEsterni = useSelector(state => state.uiPedanaMenu.hasAttacchiEsterni);
  const hasOmbrelloniContrapposti = useSelector(state => state.uiOmbrelloniMenu.ombrelloniContrapposti);
  const configurazioneOmbrelloniContrapposti = useSelector(state => state.uiOmbrelloniMenu.confOmbrelloniContrapposti);
  
  const spessorePavimento = 0.02;
  const spessorePedana = 0.025;
  const offsetInterno = 0.05; 
  
  const attacchiEsterniThreshold = 0.01;
  
  let ingressoPosition = 0;

  // Salvataggio misure precedenti 
  const [canUnblockDimensions, setCanUnblockDimensions] = useState(false);
  const [saveLunghezza, setSaveLunghezza] = useState(lunghezza);
  const [saveLarghezza, setSaveLarghezza] = useState(lunghezza);

  const dispatch = useDispatch();
  
  // Calcola la forma della minigonna a seconda della posizione dell'ingresso e della disposizione degli ombrelloni
  const generateMinigonna = () => {
    let larghezzaMinigonna1 = 0;
    let positionMinigonna1 = 0;
    let larghezzaMinigonna2 = 0;
    let positionMinigonna2 = 0;
    if (latoIngresso === E_MainLato.Scegli.toString() || !hasRampa) {
      const positionO = new THREE.Vector3(0, altezzaPedana / 2, -larghezza / 2 + offsetInterno);
      const positionE = new THREE.Vector3(0, altezzaPedana / 2, larghezza / 2 - offsetInterno);
      const positionN = new THREE.Vector3(lunghezza / 2 - offsetInterno, altezzaPedana / 2, 0);
      const positionS = new THREE.Vector3(-lunghezza / 2 + offsetInterno, altezzaPedana / 2, 0);
      return (<>
        <Minigonna posizione={positionO} altezza={altezzaPedana - spessorePavimento} lunghezza={lunghezza - offsetInterno - spessorePavimento - 0.02} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
        <Minigonna posizione={positionE} altezza={altezzaPedana - spessorePavimento} lunghezza={lunghezza - offsetInterno - spessorePavimento - 0.02} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
        <Minigonna posizione={positionN} altezza={altezzaPedana - spessorePavimento} larghezza={larghezza - offsetInterno - spessorePavimento} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} />
        <Minigonna posizione={positionS} altezza={altezzaPedana - spessorePavimento} larghezza={larghezza - offsetInterno - spessorePavimento} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} />
      </>)
    }
    else if (latoIngresso === E_MainLato.Lato1.toString()) {     
      // Calcola l'ingresso
      if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato2.toString() && larghezza > dataOmbrelloni[0].secondaryDimension) {
          larghezzaMinigonna1 = dataOmbrelloni[0].secondaryDimension/2 -0.5 - offsetInterno + 0.02;
          positionMinigonna1 = -larghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
          larghezzaMinigonna2 = larghezza - larghezzaMinigonna1 -1 - offsetInterno - 0.02;
          positionMinigonna2 = larghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02; 
          ingressoPosition = -larghezza/2 + dataOmbrelloni[0].secondaryDimension/2;             
        }
      else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
          (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
          latoOmbrelloni.toString() === E_MainLato.Lato4.toString() && larghezza > dataOmbrelloni[0].secondaryDimension) {
            larghezzaMinigonna2 = dataOmbrelloni[0].secondaryDimension/2 -0.5 - offsetInterno + 0.02;
            positionMinigonna2 = larghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;
            larghezzaMinigonna1 = larghezza - larghezzaMinigonna2 -1 - offsetInterno - 0.02;
            positionMinigonna1 = -larghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;  
            ingressoPosition = larghezza/2 - dataOmbrelloni[0].secondaryDimension/2;       
          }
      else {
        larghezzaMinigonna1 = larghezza/2 - 0.5 - offsetInterno + 0.02;
        positionMinigonna1 = -larghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
        larghezzaMinigonna2 = larghezza/2 - 0.5 - offsetInterno + 0.02;
        positionMinigonna2 = larghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;    
        ingressoPosition = 0;
      }
      const positionS1 = new THREE.Vector3(-lunghezza / 2 + offsetInterno + 0.007, altezzaPedana / 2, positionMinigonna1);
      const positionS2 = new THREE.Vector3(-lunghezza / 2 + offsetInterno + 0.007, altezzaPedana / 2, positionMinigonna2);
      const positionO = new THREE.Vector3(0, altezzaPedana / 2, -larghezza / 2 + offsetInterno);
      const positionE = new THREE.Vector3(0, altezzaPedana / 2, larghezza / 2 - offsetInterno);     
      const positionN = new THREE.Vector3(lunghezza / 2 - offsetInterno, altezzaPedana / 2, 0);
      return (<>
        <Minigonna posizione={positionS1} altezza={altezzaPedana - spessorePavimento} larghezza={larghezzaMinigonna1} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} />
        <Minigonna posizione={positionS2} altezza={altezzaPedana - spessorePavimento} larghezza={larghezzaMinigonna2} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} /> 
        <Minigonna posizione={positionO} altezza={altezzaPedana - spessorePavimento} lunghezza={lunghezza - offsetInterno - spessorePavimento - 0.02} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
        <Minigonna posizione={positionE} altezza={altezzaPedana - spessorePavimento} lunghezza={lunghezza - offsetInterno - spessorePavimento - 0.02} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
        <Minigonna posizione={positionN} altezza={altezzaPedana - spessorePavimento} larghezza={larghezza - offsetInterno - spessorePavimento} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} />
      </>)
    }
    else if (latoIngresso === E_MainLato.Lato2.toString()) {   
      // Calcola l'ingresso
      if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato1.toString() && lunghezza > dataOmbrelloni[0].secondaryDimension) {
          larghezzaMinigonna1 = dataOmbrelloni[0].secondaryDimension/2 -0.5 - offsetInterno + 0.02;
          positionMinigonna1 = -lunghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
          larghezzaMinigonna2 = lunghezza - larghezzaMinigonna1 -1 - offsetInterno - 0.02;
          positionMinigonna2 = lunghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;   
          ingressoPosition = -lunghezza/2 + dataOmbrelloni[0].secondaryDimension/2;      
        }
      else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
          (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
          latoOmbrelloni.toString() === E_MainLato.Lato3.toString() && lunghezza > dataOmbrelloni[0].secondaryDimension) {
            larghezzaMinigonna2 = dataOmbrelloni[0].secondaryDimension/2 -0.5 - offsetInterno + 0.02;
            positionMinigonna2 = lunghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;
            larghezzaMinigonna1 = lunghezza - larghezzaMinigonna2 -1 - offsetInterno - 0.02;
            positionMinigonna1 = -lunghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
            ingressoPosition = lunghezza/2 - dataOmbrelloni[0].secondaryDimension/2;   
          }
      else {
        larghezzaMinigonna1 = lunghezza/2 - 0.5 - offsetInterno + 0.02;
        positionMinigonna1 = -lunghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
        larghezzaMinigonna2 = lunghezza/2 - 0.5 - offsetInterno + 0.02;
        positionMinigonna2 = lunghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;
        ingressoPosition = 0;   
      }  
      const positionE = new THREE.Vector3(lunghezza/2 - offsetInterno - 0.007, altezzaPedana / 2, 0);    
      const positionO1 = new THREE.Vector3(positionMinigonna1, altezzaPedana / 2, -larghezza / 2  + offsetInterno);
      const positionO2 = new THREE.Vector3(positionMinigonna2, altezzaPedana / 2, -larghezza / 2  + offsetInterno);
      const positionN = new THREE.Vector3(0, altezzaPedana / 2, larghezza / 2 - offsetInterno);     
      const positionS = new THREE.Vector3(-lunghezza / 2 + offsetInterno, altezzaPedana / 2, 0);
      return (<>       
        <Minigonna posizione={positionE} altezza={altezzaPedana - spessorePavimento} larghezza={larghezza - offsetInterno - spessorePavimento} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} /> 
        <Minigonna posizione={positionO1} altezza={altezzaPedana - spessorePavimento} lunghezza={larghezzaMinigonna1} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
        <Minigonna posizione={positionO2} altezza={altezzaPedana - spessorePavimento} lunghezza={larghezzaMinigonna2} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
        <Minigonna posizione={positionN} altezza={altezzaPedana - spessorePavimento} lunghezza={lunghezza - offsetInterno - spessorePavimento - 0.02} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
        <Minigonna posizione={positionS} altezza={altezzaPedana - spessorePavimento} larghezza={larghezza - offsetInterno - spessorePavimento} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} />
      </>)
    }
    else if (latoIngresso === E_MainLato.Lato3.toString()) {
      // Calcola l'ingresso
      if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato2.toString() && larghezza > dataOmbrelloni[0].secondaryDimension) {
          larghezzaMinigonna1 = dataOmbrelloni[0].secondaryDimension/2 -0.5 - offsetInterno + 0.02;
          positionMinigonna1 = -larghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
          larghezzaMinigonna2 = larghezza - larghezzaMinigonna1 -1 - offsetInterno - 0.02;
          positionMinigonna2 = larghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;
          ingressoPosition = -larghezza/2 + dataOmbrelloni[0].secondaryDimension/2;          
        }
      else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
          (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
          latoOmbrelloni.toString() === E_MainLato.Lato4.toString() && larghezza > dataOmbrelloni[0].secondaryDimension) {
            larghezzaMinigonna2 = dataOmbrelloni[0].secondaryDimension/2 -0.5 - offsetInterno + 0.02;
            positionMinigonna2 = larghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;
            larghezzaMinigonna1 = larghezza - larghezzaMinigonna2 -1 - offsetInterno - 0.02;
            positionMinigonna1 = -larghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
            ingressoPosition = larghezza/2 - dataOmbrelloni[0].secondaryDimension/2;   
          }
      else {
        larghezzaMinigonna1 = larghezza/2 - 0.5 - offsetInterno + 0.02;
        positionMinigonna1 = -larghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
        larghezzaMinigonna2 = larghezza/2 - 0.5 - offsetInterno + 0.02;
        positionMinigonna2 = larghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;
        ingressoPosition = 0;   
      }
      const positionN1 = new THREE.Vector3(lunghezza / 2 - offsetInterno - 0.007, altezzaPedana / 2, positionMinigonna1);
      const positionN2 = new THREE.Vector3(lunghezza / 2 - offsetInterno - 0.007, altezzaPedana / 2, positionMinigonna2);
      const positionO = new THREE.Vector3(0, altezzaPedana / 2, -larghezza / 2 + offsetInterno);
      const positionE = new THREE.Vector3(0, altezzaPedana / 2, larghezza / 2 - offsetInterno);     
      const positionS = new THREE.Vector3(-lunghezza / 2 + offsetInterno, altezzaPedana / 2, 0);
      return (<>
        <Minigonna posizione={positionN1} altezza={altezzaPedana - spessorePavimento} larghezza={larghezzaMinigonna1} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} />
        <Minigonna posizione={positionN2} altezza={altezzaPedana - spessorePavimento} larghezza={larghezzaMinigonna2} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} />
        <Minigonna posizione={positionO} altezza={altezzaPedana - spessorePavimento} lunghezza={lunghezza - offsetInterno - spessorePavimento - 0.02} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
        <Minigonna posizione={positionE} altezza={altezzaPedana - spessorePavimento} lunghezza={lunghezza - offsetInterno - spessorePavimento - 0.02} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
        <Minigonna posizione={positionS} altezza={altezzaPedana - spessorePavimento} larghezza={larghezza - offsetInterno - spessorePavimento} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} />
      </>)
    }
    else if (latoIngresso === E_MainLato.Lato4.toString()) {
      // Calcola l'ingresso
      if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato1.toString() && lunghezza > dataOmbrelloni[0].secondaryDimension) {
          larghezzaMinigonna1 = dataOmbrelloni[0].secondaryDimension/2 -0.5 - offsetInterno + 0.02;
          positionMinigonna1 = -lunghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
          larghezzaMinigonna2 = lunghezza - larghezzaMinigonna1 -1 - offsetInterno - 0.02;
          positionMinigonna2 = lunghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;   
          ingressoPosition = -lunghezza/2 + dataOmbrelloni[0].secondaryDimension/2;     
        }
      else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
          (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
          latoOmbrelloni.toString() === E_MainLato.Lato3.toString() && lunghezza > dataOmbrelloni[0].secondaryDimension) {
            larghezzaMinigonna2 = dataOmbrelloni[0].secondaryDimension/2 -0.5 - offsetInterno + 0.02;
            positionMinigonna2 = lunghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;
            larghezzaMinigonna1 = lunghezza - larghezzaMinigonna2 -1 - offsetInterno - 0.02;
            positionMinigonna1 = -lunghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
            ingressoPosition = lunghezza/2 - dataOmbrelloni[0].secondaryDimension/2;   
          }
      else {
        larghezzaMinigonna1 = lunghezza/2 - 0.5 - offsetInterno + 0.02;
        positionMinigonna1 = -lunghezza/2 + larghezzaMinigonna1/2 + offsetInterno - 0.02;
        larghezzaMinigonna2 = lunghezza/2 - 0.5 - offsetInterno + 0.02;
        positionMinigonna2 = lunghezza/2 - larghezzaMinigonna2/2 - offsetInterno + 0.02;
        ingressoPosition = 0;   
      } 
      const positionE = new THREE.Vector3(lunghezza/2 - offsetInterno - 0.007, altezzaPedana / 2, 0);    
      const positionO = new THREE.Vector3(0, altezzaPedana / 2, -larghezza / 2 + offsetInterno);    
      const positionS = new THREE.Vector3(-lunghezza / 2 + offsetInterno, altezzaPedana / 2, 0);
      const positionN1 = new THREE.Vector3(positionMinigonna1, altezzaPedana / 2, larghezza / 2 - offsetInterno);  
      const positionN2 = new THREE.Vector3(positionMinigonna2, altezzaPedana / 2, larghezza / 2 - offsetInterno);        
      return (<>       
        <Minigonna posizione={positionE} altezza={altezzaPedana - spessorePavimento} larghezza={larghezza - offsetInterno - spessorePavimento} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} /> 
        <Minigonna posizione={positionO} altezza={altezzaPedana - spessorePavimento} lunghezza={lunghezza - offsetInterno - spessorePavimento - 0.02} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} /> 
        <Minigonna posizione={positionS} altezza={altezzaPedana - spessorePavimento} larghezza={larghezza - offsetInterno - spessorePavimento} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={Math.PI / 2} useLunghezza={false} />
        <Minigonna posizione={positionN1} altezza={altezzaPedana - spessorePavimento} lunghezza={larghezzaMinigonna1} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
        <Minigonna posizione={positionN2} altezza={altezzaPedana - spessorePavimento} lunghezza={larghezzaMinigonna2} spessore={spessorePedana} offsetInterno={offsetInterno} rotation={0} useLunghezza={true} />
      </>)
    }
  }

  // Verifica se posizionare la pavimentazione esterna a seconda del tipo di ombrellone
  const generateAttacchiEsterni = () => { 
    // Se ci sono gli ombrelloni, calcola la loro posizione rispetto alla pedana    
    if(dataOmbrelloni.length > 0) {    
      return dataOmbrelloni.map((element, index) => {  
        // Se sono ombrelloni adatti
        if (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) {
          // Se si supera la soglia negativa per piazzare il pavimento esterno
          const tipoOmbr = ombrelloniConfiguration.find(element => element.meshSpecificName.toString() === tipoOmbrelloni.toString());
          if (tipoOmbr !== undefined && tipoOmbr.offSetPosizioneOmbrellone[2] >=  attacchiEsterniThreshold) {     
            dispatch(handleHasAttacchiEsterni(true));           
          } else {
            dispatch(handleHasAttacchiEsterni(false));    
          }
        }    
      })  
    }
  }

  // Blocca le dimensioni per gli ombrelloni contrapposti
  const blockDimensions = () => {
    if (dataOmbrelloni.length > 0) {            
        if (hasOmbrelloniContrapposti) {              
            if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString() || latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) {
                setSaveLunghezza(lunghezza);
                setSaveLarghezza(larghezza);
                dispatch(handleLunghezza(dataOmbrelloni[0].secondaryDimension * 2));               
            }
            else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString() || latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) {            
                setSaveLarghezza(larghezza);
                setSaveLunghezza(lunghezza);
                dispatch(handleLarghezza(dataOmbrelloni[0].secondaryDimension * 2));
            }       
        }  
    }
    setCanUnblockDimensions(true);            
  }

  useEffect(() => {
    generateAttacchiEsterni();
  }, [dataOmbrelloni, genereOmbrelloni, tipoOmbrelloni, latoOmbrelloni, latoIngresso, lunghezza, larghezza, altezzaPedana, hasRampa, ombrelloniIsVisible])
  
  // Blocca le dimensioni della pedana per gli ombrelloni contrapposti
  useEffect(() => {
    // Se ha gli ombrelloni contrapposti blocca le dimensioni
    if (hasOmbrelloniContrapposti) {
      blockDimensions(); 
    }
    if (canUnblockDimensions) {
        dispatch(handleLunghezza(saveLunghezza));   
        dispatch(handleLarghezza(saveLarghezza));
        setCanUnblockDimensions(false);    
    }  
  }, [hasOmbrelloniContrapposti, configurazioneOmbrelloniContrapposti]);

  return (  
      <group>
        <Pavimento lunghezza={lunghezza} larghezza={larghezza} altezzaPedana={altezzaPedana} spessore={spessorePavimento} /> 
        {generateMinigonna()}  
        <Piedini altezzaPiedini={altezzaPedana} posizioneIngresso={ingressoPosition}/>
        {hasAttacchiEsterni && dataOmbrelloni.map((element, index) => (
          <PavimentoEsterno posizione={element.position} key={`pavimento_esterno_${index}`}/>
        ))}        
      </group>   
  )
}
